import Totals from "../../../model/crew/Totals";
import Page from "../../framework/Page";
import View from "../../framework/View";

export default class CurrencyContainerSectionView extends View {
    /**
     * @param {string} parentId 
     * @param {string} elementId
     * @param {string} title
     * @param {string} iconFileName
     * @param {Totals} totals 
     */
    constructor(parentId, elementId, title, iconFileName, totals) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {string}
         */
        this.title = title;
        /**
         * @constant
         * @type {string}
         */
        this.iconFileName = iconFileName;
        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;

        /**
         * @type {string}
         */
        this.displayedDescription = null;
        /**
         * @type {HTMLElement}
         */
        this.valueElement = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('CurrencyContainerSectionView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        const mainElement = Page.createElement('div', parent, id, 'currency-container-section'); // inline-block

        const bodyElement = Page.createElement('div', mainElement, null, 'currency-container-body' ); // grid-template-columns: 1fr 6fr;  'mined-upgrade-button-body'

        const iconElement = Page.createElement('div', bodyElement, null, 'icon-container');

        // <img src="images/miner_icon_51x48.png"/>
        // Use the 'icon-container' style here to force the image to be 40x40.
        const imgElement = Page.createElement('img', iconElement, null, 'icon-container'); 
        imgElement.src = this.iconFileName;

        // Title/Description container
        const titleDescriptionContainer = Page.createElement('div', bodyElement, this.elementId + '_text', 'mined-upgrade-title-description-container'); // margin left 5px

        const titleElement = Page.createElement('div', titleDescriptionContainer, null, null);
        titleElement.innerHTML = this.title;

        // Create the description element.
        this.valueElement = Page.createElement('div', titleDescriptionContainer, null, 'mined-upgrade-button-description'); // margin top 5px
        this.valueElement.innerHTML = '';

        // Initialize the upgrade button as visible.
        this.setInitialVisibility(true);

        super.initializeView();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }


}